const BASE_ATTRIBUTE = 'data-component';
export const NAME_ATTRIBUTE = "".concat(BASE_ATTRIBUTE, "-name");
export const RENDER_EVENT = '__renderedTangramLayoutComponent';
export const UNMOUNT_EVENT = '__unmountedTangramLayoutComponent';